import { Injectable } from '@angular/core';
import { IDashboard, IFiltroDashboard } from './adm-dashboard.service';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardService {
    private baseUrl = `dashboard`;

    constructor(protected apiService: ApiService) {}

    public getDashboard(filtro: IFiltroDashboard) {
        return this.apiService.get(this.baseUrl, filtro) as unknown as Observable<IDashboard>;
    }
}
